import React, { useState, useCallback } from 'react'
import { withTranslation } from 'react-i18next'
import ModalBody from 'app/components/Modal/ModalBody'
import Button from 'app/components/ButtonDefault'
import PauseOrOutOfOffice from 'app/domains/routes/Dashboard/PauseOrOutOfOffice'
import { PAUSE_BUTTONS } from 'app/constants/pauseButtons'
import { IConfirmModalProps } from './interface'
import './styles.scss'

const bc = 'confirm-or-cancel'

const ConfirmationModal: React.FC<IConfirmModalProps> = ({
  t,
  onRequestClose,
  title,
  confirmBtn = t('Confirm'),
  cancelBtn = t('Cancel'),
  text,
  isShowPauseOutOfOfficeButtons,
  outBtn,
  pauseBtn,
  dangerouslyText,
  handleSubmit,
  children,
  showButtons = true,
}) => {
  const [state, setState] = useState(PAUSE_BUTTONS.OUT_OF_OFFICE)
  const handleConfirm = useCallback(() => {
    /**
     * handleSubmit(state) - works only when you trying to stop ProTrack by using link in email letter
     * handleSubmit() - redux-form onSubmit trigger
     */
    isShowPauseOutOfOfficeButtons ? handleSubmit(state) : handleSubmit()
  }, [handleSubmit, state])

  const handleClose = useCallback(() => {
    onRequestClose()
  }, [onRequestClose])

  return (
    <ModalBody className={`${bc}__wrapper`} onRequestClose={onRequestClose} title={title}>
      {text && <div className={`${bc}__text`}>{text}</div>}
      {dangerouslyText && <div className={`${bc}__dangerouslyText`} dangerouslySetInnerHTML={dangerouslyText} />}
      {isShowPauseOutOfOfficeButtons && (
        <PauseOrOutOfOffice pauseBtn={pauseBtn} outBtn={outBtn} setState={setState} state={state} />
      )}
      {children
        ? React.isValidElement(children)
          ? React.cloneElement(children)
          : // @ts-ignore
            React.createElement(children)
        : null}
      {showButtons && (
        <div className={`${bc}__body`}>
          <Button onClick={handleClose} outlineSecondary className="cancelButton">
            {cancelBtn}
          </Button>

          <Button onClick={handleConfirm} stretched className="confirmButton">
            {confirmBtn}
          </Button>
        </div>
      )}
    </ModalBody>
  )
}

export default withTranslation('common')(ConfirmationModal as any)
